import { initializeApp } from "firebase/app"
import { getDatabase } from "firebase/database"

const firebaseConfig = {
  apiKey: "AIzaSyBIO5-3C8Fo3usNsxsLBz-BHCmIs-a-EGg",
  authDomain: "paks25-192d1.firebaseapp.com",
  databaseURL: "https://paks25-192d1-default-rtdb.firebaseio.com",
  projectId: "paks25-192d1",
  storageBucket: "paks25-192d1.firebasestorage.app",
  messagingSenderId: "54757272892",
  appId: "1:54757272892:web:f5de0c7de88c711dfac239",
}

const app = initializeApp(firebaseConfig)
const database = getDatabase(app)

export { database }

